import { render, staticRenderFns } from "./PhysicalCollection.vue?vue&type=template&id=2bbc7925&scoped=true"
import script from "./PhysicalCollection.vue?vue&type=script&lang=js"
export * from "./PhysicalCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbc7925",
  null
  
)

export default component.exports